import { put, select } from 'redux-saga/effects';
import { openCellEditor } from './viewsActions';
import {
  SheetAndView,
  selectSheetAndView,
  selectValidationRuleFromPosition,
} from '../../../selectors/sheetSelector';
import { createArrayAreaAddressFromPosition } from '../../../utils/area/area';
import {
  CellPosition,
  CellValue,
  ValidationCriteria,
  ValidationRule,
} from '../../../types';
import { getCell, getCellVisibleValue } from '../../../utils/cells/cellCRUD';
import {
  isValidCheckboxValue,
  isValidIconSetValue,
} from '../../../helpers/cellView/cellValidationRule';
import { handleSheetOperations } from '../root/rootActions';
import {
  CellInput,
  SheetCommandType,
} from '../../../types/commands/sheetCommands/sheetCommands';

export function* openCellEditorMi({
  payload,
}: ReturnType<typeof openCellEditor>) {
  const { position, sheetId, key } = payload;

  const { sheet, sheetView }: SheetAndView = yield select((state) =>
    selectSheetAndView(state, sheetId)
  );
  if (!sheet || !sheetView) return;

  const {
    dataValidationMatrix,
    dataValidationsMap,
    dataValidationRules,
    cells,
  } = sheet;

  const cellPosition = position ?? sheetView.activeCell;
  const { visibleValue, isError } = getCellVisibleValue(cells, cellPosition);

  const rule = selectValidationRuleFromPosition(
    dataValidationMatrix,
    dataValidationsMap,
    dataValidationRules,
    cellPosition,
    createArrayAreaAddressFromPosition(cellPosition)
  );

  //   console.log('rule', rule);

  if (rule && key && key === ' ' && !isError) {
    const stopExecution: boolean = yield jumpValueUsingRule(
      sheetId,
      cellPosition,
      rule,
      visibleValue
    );
    // console.log('stopExecution', stopExecution);
    if (stopExecution) return;
  }
}

function* jumpValueUsingRule(
  sheetId: string,
  position: CellPosition,
  rule: ValidationRule,
  cellValue: string
) {
  let command: CellInput | undefined;
  const partialCommand: Omit<CellInput, 'value'> = {
    type: SheetCommandType.CellInput,
    sheetId,
    position,
  };

  const isCheckbox = rule.criteria === ValidationCriteria.Checkbox;
  const isIconSet = rule.criteria === ValidationCriteria.IconSets;

  if (isCheckbox) {
    const { isValid, checkedString, uncheckedString, isChecked } =
      isValidCheckboxValue(rule, cellValue);

    if (isValid) {
      command = {
        ...partialCommand,
        value: isChecked ? uncheckedString : checkedString,
      };
    }
  } else if (isIconSet) {
    const { isValid, nextValue } = isValidIconSetValue(rule, cellValue);
    if (isValid) {
      command = {
        ...partialCommand,
        value: nextValue,
      };
    }
  }

  if (command) {
    yield put(handleSheetOperations(command));
  }

  return !!command;
}

function* closeCellEditor() {}
